// extracted by mini-css-extract-plugin
module.exports = {"DiscountCode__code":"styles_DiscountCode__code__oDuIx","DiscountCode__svg":"styles_DiscountCode__svg__S9xN_","small":"styles_small__LvPtg"};